/* Mural "o que falam da Amana" — sections/amana-mural.liquid (05/10/2026).
 *
 * 1. pede os posts à API do Worker amana-mural (só os aprovados);
 * 2. desenha conforme o layout: duas colunas que andam (home), faixa (PDP)
 *    ou grade com filtro (página);
 * 3. completa o produto de cada post por /products/<handle>.js (nome, foto,
 *    preço, variante) — o Worker só sabe o handle;
 * 4. abre a JANELA do post: player oficial da rede, texto, link original e
 *    o produto com "Adicionar ao carrinho" (data-am-add-rapido, o mesmo
 *    caminho dos cartões: adiciona e abre o carrinho da casa).
 *
 * Todo texto que vem da API entra por textContent, nunca por innerHTML. */
(function () {
  'use strict';
  if (window.__amMural) return;
  window.__amMural = true;

  var ICONES = {
    instagram: 'M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.2-2.2-.4a3.9 3.9 0 0 1-1.4-.9 3.9 3.9 0 0 1-.9-1.4c-.2-.4-.4-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4C8.4 2.2 8.8 2.2 12 2.2Zm0 3.2A6.6 6.6 0 1 0 18.6 12 6.6 6.6 0 0 0 12 5.4Zm0 10.9A4.3 4.3 0 1 1 16.3 12 4.3 4.3 0 0 1 12 16.3Zm6.9-11.1a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Z',
    tiktok: 'M16.5 2h-3v13.2a2.6 2.6 0 1 1-2-2.5V9.5a5.8 5.8 0 1 0 5 5.7V9a7 7 0 0 0 4 1.3V7.2a4 4 0 0 1-4-4Z',
    youtube: 'M22 12s0-3.2-.4-4.7a2.5 2.5 0 0 0-1.7-1.7C18.3 5.2 12 5.2 12 5.2s-6.3 0-7.9.4a2.5 2.5 0 0 0-1.7 1.7C2 8.8 2 12 2 12s0 3.2.4 4.7a2.5 2.5 0 0 0 1.7 1.7c1.6.4 7.9.4 7.9.4s6.3 0 7.9-.4a2.5 2.5 0 0 0 1.7-1.7C22 15.2 22 12 22 12Zm-12 3V9l5.2 3Z',
    x: 'M17.8 3h3.1l-6.8 7.8 8 10.2h-6.3l-4.9-6.4L5.3 21H2.2l7.3-8.3L1.8 3h6.4l4.4 5.9L17.8 3Zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5Z',
    facebook: 'M14 8h2.5V4.6C16 4.5 15 4.4 14 4.4c-2.5 0-4.2 1.5-4.2 4.3V11H7v3.4h2.8V22h3.4v-7.6h2.8l.4-3.4h-3.2V9.3c0-1 .3-1.3.8-1.3Z',
    linkedin: 'M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.75h4V21H3V9.75Zm6.5 0h3.8v1.6h.06c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.77 2.6 4.77 6V21h-4v-5c0-1.2 0-2.75-1.68-2.75s-1.94 1.3-1.94 2.66V21h-4V9.75Z',
    pinterest: 'M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.5 2.1-.8 3.3-.2 1 .5 1.8 1.5 1.8 1.8 0 3.1-1.9 3.1-4.6 0-2.4-1.7-4.1-4.2-4.1-2.9 0-4.5 2.1-4.5 4.4 0 .9.3 1.8.8 2.3l.1.4-.3 1.2c0 .2-.2.3-.4.2-1.3-.6-2-2.4-2-3.9 0-3.2 2.3-6.1 6.6-6.1 3.5 0 6.2 2.5 6.2 5.8 0 3.4-2.2 6.2-5.2 6.2-1 0-2-.5-2.3-1.1l-.6 2.4c-.2.9-.8 2-1.3 2.6A10 10 0 1 0 12 2Z',
    blog: 'M4 20h4.2L19.4 8.8a2 2 0 0 0 0-2.8l-1.4-1.4a2 2 0 0 0-2.8 0L4 15.8V20Zm2-2v-1.4l8.4-8.4 1.4 1.4L7.4 18H6Z',
    imprensa: 'M4 4h13v14a2 2 0 0 0 2 2H6a2 2 0 0 1-2-2V4Zm2 2v12h9.2c-.1-.3-.2-.6-.2-1V6H6Zm1.5 1.5h6v3h-6v-3Zm0 4.5h6v1.4h-6V12Zm0 2.8h6v1.4h-6v-1.4ZM19 8h2v10a2 2 0 0 1-2 2V8Z',
    outro: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm6.9 6h-3a15 15 0 0 0-1.3-3.9A8 8 0 0 1 18.9 8ZM12 4c.9 1.1 1.6 2.5 2 4h-4c.4-1.5 1.1-2.9 2-4ZM4.3 14a8 8 0 0 1 0-4h3.4a16 16 0 0 0 0 4H4.3Zm.8 2h3a15 15 0 0 0 1.3 3.9A8 8 0 0 1 5.1 16Zm3-8h-3a8 8 0 0 1 4.3-3.9C8.9 5.3 8.4 6.6 8.1 8ZM12 20c-.9-1.1-1.6-2.5-2-4h4c-.4 1.5-1.1 2.9-2 4Zm2.3-6H9.7a14 14 0 0 1 0-4h4.6a14 14 0 0 1 0 4Zm.3 5.9c.6-1.2 1-2.5 1.3-3.9h3a8 8 0 0 1-4.3 3.9Zm1.7-5.9a16 16 0 0 0 0-4h3.4a8 8 0 0 1 0 4h-3.4Z'
  };
  var NOMES = { instagram: 'Instagram', tiktok: 'TikTok', youtube: 'YouTube', x: 'X', facebook: 'Facebook', linkedin: 'LinkedIn', pinterest: 'Pinterest', blog: 'Blog', imprensa: 'Imprensa', outro: 'Na web' };
  var VER_EM = { instagram: 'Ver no Instagram', tiktok: 'Ver no TikTok', youtube: 'Ver no YouTube', x: 'Ver no X', facebook: 'Ver no Facebook', linkedin: 'Ver no LinkedIn', pinterest: 'Ver no Pinterest', blog: 'Ler a matéria completa', imprensa: 'Ler a matéria completa', outro: 'Abrir o original' };
  var MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  function raiz() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function svg(d, cls) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', d); s.appendChild(p);
    return s;
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function quando(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    return Number(p[2]) + ' ' + MESES[Number(p[1]) - 1] + ' ' + p[0];
  }
  function quem(m) {
    if (m.rede === 'blog' || m.rede === 'imprensa' || m.rede === 'outro') return m.veiculo || m.autor || NOMES[m.rede];
    return m.usuario ? '@' + m.usuario : (m.autor || NOMES[m.rede]);
  }
  function grupo(m) { return (m.rede === 'blog' || m.rede === 'imprensa' || m.rede === 'outro') ? 'imprensa' : m.rede; }

  /* ---------------- produtos (cache por handle) ---------------- */
  var PROD = {};
  function produto(h) {
    if (!PROD[h]) {
      PROD[h] = fetch(raiz() + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return PROD[h];
  }
  function preco(c) {
    try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL' }); }
    catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  }
  function img(src, w) {
    if (!src) return '';
    src = src.replace(/^\/\//, 'https://');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------------- o cartão ---------------- */
  function cartao(m, idx, ctx) {
    var a = el('article', 'am-mur-c am-mur-c--' + m.rede + (m.capa ? '' : ' am-mur-c--txt') + (m.video ? ' am-mur-c--video' : ''));
    var r = (m.capa_w && m.capa_h) ? m.capa_h / m.capa_w : 1.25;
    if (ctx.modo === 'lado') r = Math.min(1.5, Math.max(0.8, m.vertical ? 1.5 : r));
    a.style.setProperty('--am-mur-ar', '1 / ' + r.toFixed(3));
    if (m.capa) {
      var im = el('img', 'am-mur-c__img');
      im.src = m.capa; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
      if (m.capa_w) { im.width = m.capa_w; im.height = m.capa_h; }
      a.appendChild(im);
    } else {
      a.appendChild(el('p', 'am-mur-c__cit', m.titulo || m.texto || ''));
    }
    var chip = el('span', 'am-mur-c__rede'), b = el('b');
    b.appendChild(svg(ICONES[m.rede] || ICONES.outro));
    b.appendChild(document.createTextNode(quem(m)));
    chip.appendChild(b); a.appendChild(chip);
    if (m.video) { var pl = el('span', 'am-mur-c__play'); pl.appendChild(svg('M8 5.5v13l11-6.5z')); a.appendChild(pl); }
    if (m.capa) {
      var t = (m.rede === 'blog' || m.rede === 'imprensa') ? (m.titulo || m.texto) : (m.texto || m.titulo);
      // no cartão as hashtags só fazem ruído (a legenda inteira fica na janela)
      if (t) t = t.replace(/#[\p{L}\p{N}_]+/gu, '').replace(/\s*\n+\s*/g, ' ').replace(/\s{2,}/g, ' ').trim();
      if (t) a.appendChild(el('p', 'am-mur-c__txt', t));
    }
    var abre = el('button', 'am-mur-c__abre');
    abre.type = 'button';
    abre.setAttribute('aria-label', (m.video ? 'Ver vídeo de ' : 'Abrir publicação de ') + quem(m) + ' — ' + (NOMES[m.rede] || ''));
    abre.addEventListener('click', function () { janela.abrir(ctx.lista, idx, abre); });
    a.appendChild(abre);

    var h = (m.produtos || [])[0];
    if (h) {
      var link = el('a', 'am-mur-c__prod');
      link.href = raiz() + 'products/' + h;
      link.hidden = true;
      var mini = el('span', 'am-mur-c__mini'), nome = el('span', 'am-mur-c__nome'), seta = el('i', 'am-mur-c__seta');
      seta.setAttribute('aria-hidden', 'true');
      var ss = svg('M5 12h13M13 6.5l5.5 5.5-5.5 5.5'); seta.appendChild(ss);
      link.appendChild(mini); link.appendChild(nome); link.appendChild(seta);
      a.appendChild(link);
      produto(h).then(function (p) {
        if (!p || p.available === false) return; // produto esgotado/inativo: sem barra
        nome.textContent = p.title;
        if (p.featured_image) { var mi = el('img'); mi.src = img(p.featured_image, 120); mi.alt = ''; mi.loading = 'lazy'; mini.appendChild(mi); }
        link.setAttribute('aria-label', 'Comprar ' + p.title);
        link.hidden = false;
      });
    }
    return a;
  }

  function esqueleto(n, modo) {
    var f = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var c = el('div', 'am-mur-c am-mur-c--esq');
      if (modo === 'lado') c.style.setProperty('--am-mur-ar', '1 / ' + [1.25, 1.45, 1, 1.3][i % 4]);
      f.appendChild(c);
    }
    return f;
  }

  /* ---------------- HOME: duas colunas que andam ---------------- */
  function colunas(sec, lista, ctx) {
    var cols = sec.querySelectorAll('[data-am-mur-col]');
    var palco = sec.querySelector('[data-am-mur-palco]');
    var fitas = [cols[0].querySelector('[data-am-mur-fita]'), cols[1].querySelector('[data-am-mur-fita]')];
    var partes = [[], []];
    lista.forEach(function (m, i) { partes[i % 2].push(i); });
    if (lista.length === 1) partes[1] = [0];
    function monta() {
      fitas.forEach(function (f, k) {
        f.textContent = '';
        var idxs = partes[k];
        if (!idxs.length) return;
        // repete até passar da altura do palco; depois DOBRA (a animação anda metade)
        var meia = document.createDocumentFragment(), n = 0, alt = 0, limite = palco.clientHeight + 40;
        var larg = cols[k].clientWidth || 200;
        while ((alt < limite || n < idxs.length) && n < 80) {
          var i = idxs[n % idxs.length], m = lista[i];
          var r = (m.capa_w && m.capa_h) ? m.capa_h / m.capa_w : 1.25;
          r = Math.min(1.5, Math.max(0.8, m.vertical ? 1.5 : r));
          alt += larg * r + 6;
          meia.appendChild(cartao(m, i, ctx));
          n++;
        }
        var copia = meia.cloneNode(true);
        f.appendChild(meia);
        // a cópia é só visual: sem foco e sem leitor de tela, cliques religados
        Array.prototype.forEach.call(copia.children, function (c, j) {
          c.setAttribute('aria-hidden', 'true');
          c.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = -1; });
          var i = idxs[j % idxs.length];
          c.querySelector('.am-mur-c__abre').addEventListener('click', function () { janela.abrir(lista, i, null); });
          var orig = f.children[j], pb = orig && orig.querySelector('.am-mur-c__prod'), pc = c.querySelector('.am-mur-c__prod');
          if (pb && pc) {
            // a barra do original completa depois (fetch do produto): copia quando chegar
            produto(lista[i].produtos[0]).then(function () { pc.parentNode.replaceChild(pb.cloneNode(true), pc); var nb = c.querySelector('.am-mur-c__prod'); nb.tabIndex = -1; });
          }
        });
        f.appendChild(copia);
        // velocidade constante (~26 px/s), qualquer que seja a altura
        var meiaAlt = f.scrollHeight / 2;
        f.style.setProperty('--am-mur-dur', Math.max(25, meiaAlt / 26).toFixed(1) + 's');
      });
      sec.classList.add('am-mur--anda');
    }
    monta();
    var largAntes = palco.clientWidth;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (Math.abs(palco.clientWidth - largAntes) < 40) return;
        largAntes = palco.clientWidth; monta();
      }).observe(palco);
    }
    // fora da tela não anda (economia de bateria; o scroll é do .page-wrapper,
    // então só IntersectionObserver serve)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sec.classList.toggle('am-mur--fora', !e.isIntersecting); });
        sec.classList.toggle('am-mur--parado', sec.classList.contains('am-mur--fora') || sec.__amMurPausa === true);
      }, { rootMargin: '100px 0px' }).observe(palco);
    }
    var bp = sec.querySelector('[data-am-mur-pausa]');
    if (bp) bp.addEventListener('click', function () {
      sec.__amMurPausa = !sec.__amMurPausa;
      bp.setAttribute('aria-pressed', sec.__amMurPausa ? 'true' : 'false');
      sec.classList.toggle('am-mur--parado', sec.__amMurPausa || sec.classList.contains('am-mur--fora'));
    });
  }

  /* ---------------- PDP: faixa ---------------- */
  function faixa(sec, lista, ctx) {
    var t = sec.querySelector('[data-am-mur-lista]');
    t.textContent = '';
    lista.forEach(function (m, i) { t.appendChild(cartao(m, i, ctx)); });
    // o carrossel de biscoito mede o trilho no resize: avisa que mudou
    requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
  }

  /* ---------------- PÁGINA: grade com filtro ---------------- */
  function grade(sec, lista, ctx) {
    var g = sec.querySelector('[data-am-mur-lista]');
    var fb = sec.querySelector('[data-am-mur-filtros]');
    var mais = sec.querySelector('[data-am-mur-mais]');
    var filtro = sec.getAttribute('data-am-mur-filtro') || 'todos';
    var POR = 12, mostrando = POR;
    var grupos = [['todos', 'Todos', null]];
    var cont = { todos: lista.length, videos: 0 };
    lista.forEach(function (m) { var gk = grupo(m); cont[gk] = (cont[gk] || 0) + 1; if (m.video) cont.videos++; });
    if (cont.videos) grupos.push(['videos', 'Vídeos', 'M8 5.5v13l11-6.5z']);
    ['instagram', 'tiktok', 'youtube', 'x', 'facebook', 'linkedin', 'pinterest', 'imprensa'].forEach(function (k) {
      if (cont[k]) grupos.push([k, k === 'imprensa' ? 'Imprensa e blogs' : NOMES[k], ICONES[k]]);
    });
    if (!cont[filtro] && filtro !== 'todos') filtro = 'todos';
    function filtrada() {
      return lista.map(function (m, i) { return i; }).filter(function (i) {
        var m = lista[i];
        return filtro === 'todos' || (filtro === 'videos' ? m.video : grupo(m) === filtro);
      });
    }
    function pinta() {
      var idxs = filtrada();
      g.textContent = '';
      ctx.lista = idxs.map(function (i) { return lista[i]; });
      ctx.lista.slice(0, mostrando).forEach(function (m, j) { g.appendChild(cartao(m, j, ctx)); });
      if (!idxs.length) g.appendChild(el('p', 'am-mur__vazio', 'Nada por aqui ainda.'));
      mais.hidden = idxs.length <= mostrando;
      fb.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-k') === filtro ? 'true' : 'false'); });
    }
    if (grupos.length > 2) {
      fb.textContent = '';
      grupos.forEach(function (gr) {
        var b = el('button'); b.type = 'button'; b.setAttribute('data-k', gr[0]);
        if (gr[2]) b.appendChild(svg(gr[2]));
        b.appendChild(document.createTextNode(gr[1] + ' '));
        b.appendChild(el('small', null, String(cont[gr[0]])));
        b.addEventListener('click', function () { filtro = gr[0]; mostrando = POR; pinta(); });
        fb.appendChild(b);
      });
      fb.hidden = false;
    }
    mais.addEventListener('click', function () { mostrando += POR; pinta(); });
    pinta();
  }

  /* ---------------- a janela do post ---------------- */
  var janela = (function () {
    var dlg, midia, info, lista, idx, volta, prev, next;
    function monta() {
      if (dlg) return;
      dlg = el('dialog', 'am-mur-v');
      dlg.setAttribute('aria-label', 'Publicação');
      dlg.innerHTML =
        '<div class="am-mur-v__cx">' +
        '<div class="am-mur-v__midia" data-m></div>' +
        '<div class="am-mur-v__info" data-i></div>' +
        '<button type="button" class="am-mur-v__fecha am-toque" aria-label="Fechar">×</button>' +
        '<button type="button" class="am-mur-v__nav am-mur-v__nav--ant am-toque" aria-label="Anterior">‹</button>' +
        '<button type="button" class="am-mur-v__nav am-mur-v__nav--prox am-toque" aria-label="Próxima">›</button>' +
        '</div>';
      document.body.appendChild(dlg);
      midia = dlg.querySelector('[data-m]'); info = dlg.querySelector('[data-i]');
      prev = dlg.querySelector('.am-mur-v__nav--ant'); next = dlg.querySelector('.am-mur-v__nav--prox');
      dlg.querySelector('.am-mur-v__fecha').addEventListener('click', fecha);
      prev.addEventListener('click', function () { vai(-1); });
      next.addEventListener('click', function () { vai(1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) fecha(); });
      dlg.addEventListener('close', function () {
        midia.textContent = ''; // para o vídeo
        document.documentElement.classList.remove('am-mur-v-aberta');
        if (volta && document.contains(volta)) volta.focus({ preventScroll: true });
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') vai(-1);
        else if (e.key === 'ArrowRight') vai(1);
      });
      // arrastar para os lados no celular
      var x0 = null;
      dlg.addEventListener('touchstart', function (e) { if (!e.target.closest('iframe')) x0 = e.touches[0].clientX; }, { passive: true });
      dlg.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 60) vai(dx < 0 ? 1 : -1);
      });
      // comprar: a janela sai da frente para o carrinho da casa abrir
      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-am-add-rapido]')) setTimeout(fecha, 50);
      });
    }
    function fecha() { if (dlg && dlg.open) dlg.close(); }
    function vai(d) { if (lista && lista.length > 1) pinta((idx + d + lista.length) % lista.length); }

    function pinta(i) {
      idx = i;
      var m = lista[i];
      prev.hidden = next.hidden = lista.length < 2;
      dlg.className = 'am-mur-v am-mur-v--' + m.rede + (m.vertical ? ' am-mur-v--vertical' : '') + (m.embed || m.video_src ? '' : ' am-mur-v--sem-player') + (m.video_src ? ' am-mur-v--proprio' : '');

      // mídia: o player oficial (iframe) ou, para matéria, a capa
      midia.textContent = '';
      if (m.video_src) {
        // cópia do vídeo no mural: toca aqui mesmo. O player do Instagram, em
        // muitos Reels, só mostra "Assistir no Instagram" e leva a pessoa embora.
        var vd = el('video', 'am-mur-v__video');
        vd.src = m.video_src;
        if (m.capa) vd.poster = m.capa;
        vd.controls = true; vd.autoplay = true; vd.playsInline = true;
        vd.setAttribute('playsinline', ''); vd.preload = 'auto';
        vd.setAttribute('aria-label', 'Vídeo de ' + quem(m));
        midia.style.backgroundImage = '';
        midia.appendChild(vd);
        // autoplay com som é barrado pelo navegador: tenta com som, cai para mudo
        var p = vd.play && vd.play();
        if (p && p.catch) p.catch(function () { vd.muted = true; vd.play().catch(function () { }); });
      } else if (m.embed) {
        var f = el('iframe', 'am-mur-v__player');
        f.src = m.embed;
        f.title = (m.video ? 'Vídeo' : 'Publicação') + ' de ' + quem(m) + ' no ' + (NOMES[m.rede] || '');
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('loading', 'eager');
        f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        // enquanto o player carrega, a capa fica atrás
        if (m.capa) midia.style.backgroundImage = 'url("' + m.capa.replace(/"/g, '%22') + '")';
        else midia.style.backgroundImage = '';
        midia.appendChild(f);
      } else {
        midia.style.backgroundImage = '';
        if (m.capa) { var im = el('img', 'am-mur-v__img'); im.src = m.capa; im.alt = m.titulo || ''; midia.appendChild(im); }
        else midia.appendChild(el('p', 'am-mur-v__cit', m.titulo || m.texto || ''));
      }

      // texto
      info.textContent = '';
      var topo = el('div', 'am-mur-v__topo');
      var chip = el('span', 'am-mur-v__rede'); chip.appendChild(svg(ICONES[m.rede] || ICONES.outro)); chip.appendChild(document.createTextNode(NOMES[m.rede] || ''));
      topo.appendChild(chip);
      if (m.data) topo.appendChild(el('time', 'am-mur-v__data', quando(m.data)));
      info.appendChild(topo);
      var autor = m.autor_url ? el('a', 'am-mur-v__autor') : el('p', 'am-mur-v__autor');
      if (m.autor_url) { autor.href = m.autor_url; autor.target = '_blank'; autor.rel = 'noopener'; }
      autor.appendChild(el('b', null, m.autor || quem(m)));
      if (m.usuario && m.autor && m.autor.replace(/^@/, '') !== m.usuario) autor.appendChild(el('span', null, ' @' + m.usuario));
      if (m.da_marca) autor.appendChild(el('em', 'am-mur-v__marca', 'Amana'));
      info.appendChild(autor);
      if (m.titulo && m.titulo !== m.texto) info.appendChild(el('h3', 'am-mur-v__tit', m.titulo));
      if (m.texto) info.appendChild(el('p', 'am-mur-v__txt', m.texto));
      var orig = el('a', 'am-mur-v__orig', VER_EM[m.rede] || 'Abrir o original');
      orig.href = m.url; orig.target = '_blank'; orig.rel = 'noopener';
      orig.appendChild(svg('M14 4h6v6h-2V7.4l-7.3 7.3-1.4-1.4L16.6 6H14V4ZM5 6h6v2H6v10h10v-5h2v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z'));
      info.appendChild(orig);

      // produtos citados, com comprar
      var ps = (m.produtos || []).slice(0, 3);
      if (ps.length) {
        var caixa = el('div', 'am-mur-v__prods');
        caixa.appendChild(el('p', 'am-mur-v__prods-t', ps.length > 1 ? 'Os produtos deste post' : 'O produto deste post'));
        info.appendChild(caixa);
        ps.forEach(function (h) {
          var linha = el('div', 'am-mur-v__p'); caixa.appendChild(linha);
          produto(h).then(function (p) {
            if (!p || idx !== i) { linha.remove(); return; }
            var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
            var fig = el('a', 'am-mur-v__p-img'); fig.href = raiz() + 'products/' + h;
            if (p.featured_image) { var pi = el('img'); pi.src = img(p.featured_image, 200); pi.alt = ''; fig.appendChild(pi); }
            var tx = el('div', 'am-mur-v__p-tx');
            var nm = el('a', 'am-mur-v__p-nome', p.title); nm.href = raiz() + 'products/' + h;
            tx.appendChild(nm);
            tx.appendChild(el('span', 'am-mur-v__p-preco', v ? preco(v.price) : ''));
            linha.appendChild(fig); linha.appendChild(tx);
            if (v && p.available) {
              var bt = el('button', 'am-mur-v__p-add am-toque', 'Adicionar ao carrinho');
              bt.type = 'button'; bt.setAttribute('data-am-add-rapido', v.id);
              linha.appendChild(bt);
            } else {
              linha.appendChild(el('span', 'am-mur-v__p-esg', 'Esgotado'));
            }
          });
        });
      }
      info.scrollTop = 0;
    }

    return {
      abrir: function (l, i, origem) {
        monta();
        lista = l; volta = origem || document.activeElement;
        pinta(i);
        document.documentElement.classList.add('am-mur-v-aberta');
        if (!dlg.open) dlg.showModal();
        dlg.querySelector('.am-mur-v__fecha').focus({ preventScroll: true });
      }
    };
  })();

  /* ---------------- ligar cada seção ---------------- */
  function reserva(sec) {
    try { return JSON.parse(sec.querySelector('[data-am-mur-reserva]').textContent) || []; } catch (e) { return []; }
  }
  function liga(sec) {
    if (sec.__amMur) return;
    sec.__amMur = true;
    var modo = sec.getAttribute('data-am-mur-modo');
    var api = sec.getAttribute('data-am-mur-api');
    var prod = sec.getAttribute('data-am-mur-produto');
    var lim = sec.getAttribute('data-am-mur-limite') || '30';
    var ctx = { modo: modo, lista: [] };

    // esqueleto já, para a seção não "pular" quando os posts chegarem
    if (modo === 'lado') sec.querySelectorAll('[data-am-mur-fita]').forEach(function (f) { f.appendChild(esqueleto(4, modo)); });
    else sec.querySelector('[data-am-mur-lista]').appendChild(esqueleto(modo === 'grade' ? 8 : 7, modo));

    var desenha = function (lista) {
      ctx.lista = lista;
      if (!lista.length) { sec.hidden = true; return; }
      if (modo === 'lado') colunas(sec, lista, ctx);
      else if (modo === 'grade') grade(sec, lista, ctx);
      else faixa(sec, lista, ctx);
    };
    var url = api + '/v1/mural?limite=' + lim + (prod ? '&produto=' + encodeURIComponent(prod) : '');
    var ctl = window.AbortController ? new AbortController() : null;
    var tempo = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
    fetch(url, ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) { desenha(d.itens && d.itens.length ? d.itens : reserva(sec)); })
      .catch(function () { desenha(reserva(sec)); })
      .then(function () { clearTimeout(tempo); });
  }

  function tudo() { document.querySelectorAll('[data-am-mur]').forEach(liga); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo);
  else tudo();
  document.addEventListener('shopify:section:load', tudo);
})();
